module.exports = __webpack_public_path__ + "static/img/banner.64791fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sq_img/banner.png
// module id = 2LU6
// module chunks = 18